export default __webpack_public_path__ + "static/media/Experience_iResponsive.0dc1e28f.jpg";